import type { DefaultError, Mutation, Query, QueryClientConfig } from '@tanstack/react-query';
import { MutationCache, QueryCache } from '@tanstack/react-query';

export const generateQueryConfig = (
  enableErrorHandling = false,
  handleErrorPage: (error: DefaultError) => boolean,
  handleErrorAlert: (
    error: DefaultError,
    config: Query<unknown, unknown, unknown> | Mutation<unknown, unknown, unknown>
  ) => void
): QueryClientConfig => {
  const defaultQueriesOptions = {
    // https://tanstack.com/query/latest/docs/framework/react/guides/window-focus-refetching
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: 1
  };

  if (!enableErrorHandling) {
    return {
      defaultOptions: {
        queries: defaultQueriesOptions
      }
    };
  }

  return {
    defaultOptions: {
      queries: {
        ...defaultQueriesOptions,
        // enable error page boundary
        throwOnError: handleErrorPage,
        // https://tanstack.com/query/latest/docs/framework/react/guides/network-mode#network-mode-always
        networkMode: 'always'
      },
      mutations: {
        // enable error page boundary
        throwOnError: handleErrorPage,
        networkMode: 'always'
      }
    },
    queryCache: new QueryCache({
      // enable global alert
      onError: (error, query) => handleErrorAlert(error, query)
    }),
    mutationCache: new MutationCache({
      // enable global alert
      onError: (error, _variables, _context, mutation) => handleErrorAlert(error, mutation)
    })
  };
};
